const endpoint = "/api/categories";
export const endpoints = {
  getTagList: `${endpoint}/list`,
  getSubTag: (tagId, subTagId) =>
    `${endpoint}/${tagId}/areas-of-interest/${subTagId}`,
  createSubtag: (tagId) => `${endpoint}/${tagId}/areas-of-interest`,
  updateSubtag: (tagId, subTagId) =>
    `${endpoint}/${tagId}/areas-of-interest/${subTagId}`,
};
